import {
  BLOG_AVATAR01,
  BLOG_IMG01,
  BLOG_IMG02,
  BLOG_IMG03,
  H2_BLOG_IMG01,
  H2_BLOG_IMG02,
  H2_BLOG_IMG03,
  H3_BLOG_IMG01,
  H3_BLOG_IMG02,
  H3_BLOG_IMG03,
  H3_BLOG_IMG04,
  H3_BLOG_IMG05,
  H3_BLOG_IMG06,
  H4_BLOG_IMG01,
  H4_BLOG_IMG02,
  H4_BLOG_IMG03,
  RC_POST01,
  RC_POST02,
  RC_POST03,
  RC_POST04,
} from "../lib/assets";

export const BLOGS_LIST_TWO = [
  {
    id: 1,
    href: "/blog-details",
    src: H2_BLOG_IMG01,
    src2: H3_BLOG_IMG01, 
    src3: H4_BLOG_IMG01,
    src4: BLOG_IMG01,
    tag: "Trends",
    tag2: "Insights",
    tag3: "Trends",
    tagHref: "/blog",
    title: "5 Key Trends Shaping the Future of Business: Insights for Leaders",
    subtitle:
      "Embracing disruption and innovation, the future of business is being shaped by five key trends that will revolutionize industries and transform operations. From digitalization and sustainability to talent redefinition, leaders must stay ahead ...",
    avatar: BLOG_AVATAR01,
    author: "Nithin Krishna",
    author2: "Admin",
    createdAt: "22 Jan, 2024",
  },
  {
    id: 2,
    href: "/blog-details2",
    src: H2_BLOG_IMG02,
    src2: H3_BLOG_IMG02,
    src3: H4_BLOG_IMG02,
    src4: BLOG_IMG02,
    tag: "Efficiency",
    tag2: "Consultation",
    tag3: "Efficiency",
    tagHref: "/blog",
    title: "Optimizing Operations for Efficiency: Strategies for Streamlining Processes",
    subtitle:
      "Unlock your organization's full potential by streamlining processes and eliminating inefficiencies. Effective operations optimization strategies can boost productivity, reduce costs, and drive business growth...",
    avatar: BLOG_AVATAR01,
    author: "Balaji",
    author2: "Admin",
    createdAt: "22 Jun, 2024",
  },
  {
    id: 3,
    href: "/blog-details3",
    src: H2_BLOG_IMG03,
    src2: H3_BLOG_IMG03,
    src3: H4_BLOG_IMG03,
    src4: BLOG_IMG03,
    tag: "Leadership",
    tag2: "Consultation",
    tag3: "Development",
    tagHref: "/blog",
    title: "Building a Resilient Organization: Leadership Strategies for Navigating Uncertainty",
    subtitle:
      "Building a Resilient Organization ensures business continuity & growth. By fostering adaptability, agility, and resilience, organizations can thrive in the face of disruption.",
    avatar: BLOG_AVATAR01,
    author: "Pooja",
    author2: "Admin",
    createdAt: "19 Dec, 2024",
  },
];

export const BLOG_CATEGORIES = [
  {
    label: "Business",
    value: "02",
  },
  {
    label: "Consulting",
    value: "08",
  },
  {
    label: "Corporate",
    value: "05",
  },
  {
    label: "Design",
    value: "02",
  },
  {
    label: "Fashion",
    value: "11",
  },
  {
    label: "Marketing",
    value: "12",
  },
];

export const RECENT_BLOGS = [
  {
    id: 1,
    createdAt: "22 Jan, 2023",
    href: "/blog-details",
    src: RC_POST01,
    title: "Whale Be Raised Must Be In A Month",
  },
  {
    id: 2,
    createdAt: "22 Jan, 2023",
    href: "/blog-details",
    src: RC_POST02,
    title: "Whale Be Raised Must Be In A Month",
  },
  {
    id: 3,
    createdAt: "22 Jan, 2023",
    href: "/blog-details",
    src: RC_POST03,
    title: "Whale Be Raised Must Be In A Month",
  },
  {
    id: 4,
    createdAt: "22 Jan, 2023",
    href: "/blog-details",
    src: RC_POST04,
    title: "Whale Be Raised Must Be In A Month",
  },
];

export const BLOG_TAGS = ["Finance", "Consultancy", "Data", "Agency", "Travel"];

export const BLOG_PAGE_LIST = [
  {
    id: 1,
    createdAt: "22 Jan, 2024",
    title: "5 Key Trends Shaping the Future of Business",
    subtitle:
      "Embracing disruption and innovation, the future of business is being shaped by five key trends that will revolutionize industries and transform operations.",
    tag: "Development",
    author: "Nithin Krishna",
    src: H3_BLOG_IMG01,
    //authorSrc: BLOG_AVATAR01,
    href: "/blog-details",
    tagHref: "/blog",
  },
  {
    id: 2,
    createdAt: "22 Jun, 2024",
    title: "Optimizing Operations for Efficiency: Strategies for Streamlining Processes",
    subtitle:
      "Unlock your organization's full potential by streamlining processes and eliminating inefficiencies.",
    tag: "Business",
    author: "Balaji",
    src: H3_BLOG_IMG02,
    //authorSrc: BLOG_AVATAR02,
    href: "/blog-details2",
    tagHref: "/blog",
  },
  {
    id: 3,
    createdAt: "19 Dec, 2024",
    title: "Strategies for Navigating Uncertainty",
    subtitle:
      "A Resilient Organization equips leaders with proactive strategies to navigate uncertainty, ensuring business continuity and growth.",
    tag: "Business",
    author: "Pooja",
    src: H3_BLOG_IMG03,
    //authorSrc: BLOG_AVATAR04,
    href: "/blog-details3",
    tagHref: "/blog",
  },
  {
    id: 4,
    createdAt: "24 Dec, 2024",
    title: "Strategic Solutions for Modern Businesses",
    subtitle:
      "Empower your organization with actionable strategies and expert insights. Business consultants transform challenges into opportunities, driving innovation and long-term success.",
    tag: "Consultant Advantage",
    author: "Krithika Nair",
    src: H3_BLOG_IMG04,
    //authorSrc: BLOG_AVATAR03,
    href: "/blog-details4",
    tagHref: "/blog",
  },
  {
    id: 5,
    createdAt: "16 Mar, 2023",
    title: "Building a Safer Workplace: The Pillars of Occupational Health and Safety",
    subtitle:
      "A robust occupational health and safety system protects employees and fosters a culture of care. Learn how proactive measures can reduce risks and enhance workplace well-being.",
    tag: "Occupational Health",
    author: "Nivin",
    src: H3_BLOG_IMG06,
    //authorSrc: BLOG_AVATAR06,
    href: "/blog-details5",
    tagHref: "/blog",
  },
  {
    id: 6,
    createdAt: "2 Apr, 2024",
    title: "The Art of Customer Delight: Turning Satisfaction into Advocacy",
    subtitle:
      "Satisfied customers are good, but delighted customers are better. Learn how to elevate your service and turn loyal clients into brand ambassadors and Grow Faster.",
    tag: "Customer Delight",
    author: "Yashika",
    src: H3_BLOG_IMG05,
    //authorSrc: BLOG_AVATAR05,
    href: "/blog-details6",
    tagHref: "/blog",
  },
];
